import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getSessionToken, getSessionRole } from "./shared/auth/session";

const ProtectedRoutesSuperadmin = () => {
  const token = getSessionToken();

  if (!token) return <Navigate to="/" />;

  return getSessionRole() === 'SUPERADMIN' ? <Outlet /> : <Navigate to="/home" />;
};

export default ProtectedRoutesSuperadmin;
